import * as React from "react";
import { ListSection, List, ListItem, ListItemHighlight } from "../../elements/list";
import { formatCurrency } from "@lib/common";
export class DishOptionSetList extends React.Component {
    render() {
        const { detailOptionPrices, noStockOptions } = this.props;
        const option_sets = this.props.options.reduce((arr, { option }) => {
            const index = arr.findIndex((os) => {
                if (os.id && option.option_set_id && os.id === option.option_set_id) {
                    return true;
                }
                else if (os.name === option.set_name) {
                    return true;
                }
                return false;
            });
            if (index !== -1) {
                arr[index].options.push(option);
            }
            else {
                arr.push({
                    id: option.option_set_id,
                    name: option.set_name,
                    options: [option],
                });
            }
            return arr;
        }, []);
        return (React.createElement("div", null, option_sets.map((os, i) => {
            // const freeQty = os.conditions.free_amount || 0;
            // const totalQuantity = os.options.reduce((tq, o) => tq + o.quantity, 0);
            // if (totalQuantity === 0) return null;
            // const { variablePriceOption } = menuOptionSetVariableFind(os, option_sets);
            return (React.createElement(ListSection, { key: i, className: "text-sm" },
                React.createElement("div", { className: "font-semibold" }, os.name),
                React.createElement(List, null, os.options.map((o, k) => {
                    if (o.quantity === 0)
                        return null;
                    const noStock = noStockOptions && noStockOptions.indexOf(o.id) !== -1;
                    if (detailOptionPrices) {
                        // const price = menuOptionSetVariablePrice(o, variablePriceOption);
                        if (o.quantity === 1) {
                            return (React.createElement(ListItem, { key: k, className: "r-list-item", noStock: noStock },
                                o.name,
                                o.price && !o.quantity_free ? (React.createElement(ListItemHighlight, { className: "list-item-highlight" },
                                    "+",
                                    formatCurrency(o.price))) : ("")));
                        }
                        return (React.createElement(ListItem, { key: k, className: "r-list-item", noStock: noStock },
                            o.name,
                            o.price && !o.quantity_free ? (React.createElement(ListItemHighlight, { className: "list-item-highlight" },
                                "+",
                                formatCurrency(o.price),
                                " x ",
                                o.quantity)) : (React.createElement(ListItemHighlight, { className: "list-item-highlight" },
                                "x ",
                                o.quantity))));
                    }
                    if (o.quantity === 1) {
                        return (React.createElement(ListItem, { key: k, className: "r-list-item", noStock: noStock }, o.name));
                    }
                    return (React.createElement(ListItem, { key: k, className: "r-list-item", noStock: noStock },
                        o.name,
                        " ",
                        React.createElement(ListItemHighlight, { className: "list-item-highlight" },
                            " ",
                            "x ",
                            o.quantity)));
                }))));
        })));
    }
}
//# sourceMappingURL=dish-option-set-list.js.map